import * as React from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import ErrorPage from "./ErrorPage";
import Container from "./Container";
import MapProvider from "./components/impact-map/map-setup-context/MapContext";
import { getErrorMessage } from "./getErrorMessage";
import { reportError } from "./reportError";

function FallbackErrorPage({ error }: FallbackProps) {
  return <ErrorPage message={getErrorMessage(error)} />;
}

function App() {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorPage} onError={reportError}>
      <MapProvider>
        <Container />
      </MapProvider>
    </ErrorBoundary>
  );
}

export default App;
